import * as AppTypes from '../action/types';
import defaultInitialState from './constants/default-state';

export default (state = defaultInitialState, action) => {
  switch (action.type) {
    /* Setting appCurrency */
    case AppTypes.SET_APP_CURRENCY:
      return {
        ...state,
        app: {
          ...state.app,
          currency: action.data,
        },
      };
    /* Setting appLanguage */
    case AppTypes.SET_APP_LANGUAGE:
      return {
        ...state,
        app: {
          ...state.app,
          language: action.data,
        },
      };

    /* Setting isLogged status */
    case AppTypes.SET_LOGIN_STATUS:
      return {
        ...state,
        app: {
          ...state.app,
          isLogged: action.payload,
        },
      };

    /* Setting User data from Auth-server */
    case AppTypes.SET_USER:
      return { ...state, user: { ...state.user, ...action.data } };

    /* Borrower dashboard */
    case AppTypes.SET_BORROWER_DASHBOARD_DATA:
      return { ...state, dashboard: { ...state.dashboard, ...action.data } };

    /* Investor dashboard */
    case AppTypes.SET_INVESTOR_DASHBOARD_DATA:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          ...action.data,
          // investedAmount: Number(action.data.credits) - Number(action.data.debits),
        },
      };

    /* Investor investments */
    case AppTypes.SET_INVESTOR_INVESTMENTS:
      return {
        ...state,
        investments: {
          ...state.investments,
          items: [...action.data],
          pagination: { ...action.payload },
        },
      };

    case AppTypes.SET_INVESTOR_INVESTMENT_DETAIL:
      return {
        ...state,
        investment_detail: {
          ...action.data,
        },
      };

    case AppTypes.GET_INVESTOR_OFFERS: {
      return {
        ...state,
        offers: {
          ...state.offers,
          ...(action.data.data.type === 'offered-manual'
            ? { manualLoading: true }
            : { automaticLoading: true }),
        },
      };
    }
    case AppTypes.SET_INVESTOR_OFFERS:
      return {
        ...state,
        offers: {
          ...state.offers,
          ...action.payload,
        },
      };
    case AppTypes.GET_INVESTOR_OFFERS_ERROR: {
      return {
        ...state,
        offers: {
          ...state.offers,
          ...state.payload,
        },
      };
    }

    case AppTypes.SET_INVESTOR_INVESTMENT_INSTRUCTION:
      return { ...state, instruction: { ...action.data } };

    /* Secondary market */
    case AppTypes.SET_INVESTOR_SECONDARY_MARKET:
      return {
        ...state,
        secondary_market: {
          ...state.secondary_market,
          items: [...action.data],
          pagination: { ...action.payload },
        },
      };

    /* Biddings */
    case AppTypes.SET_INVESTOR_BIDDINGS:
      return {
        ...state,
        biddings: {
          ...state.biddings,
          items: [...action.data],
          pagination: { ...action.payload },
        },
      };

    /* Setting Onboarding Borrower Step */
    case AppTypes.SET_BORROWER_ONBOARDING_STEP:
      return { ...state, onboarding: { ...state.onboarding, ...action.data } };

    /* Setting Onboarding Investor Step */
    case AppTypes.SET_INVESTOR_ONBOARDING_STEP:
      return { ...state, onboarding: { ...state.onboarding, ...action.data } };

    /* Setting Onboarding Investor Step sending status */
    case AppTypes.SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS:
      return {
        ...state,
        onboarding: { ...state.onboarding, sending_status: action.data },
      };

    /* Setting Onboarding Investor Document Types */
    case AppTypes.SET_ONBOARDING_DOCUMENT_TYPES:
      return {
        ...state,
        onboarding_document_types: action.data,
      };

    /* FAQ's  */
    case AppTypes.SET_FAQ_CATEGORIES:
      return {
        ...state,
        faq: {
          ...state.faq,
          categories: action.data,
        },
      };

    case AppTypes.SET_FAQ_QUESTIONS:
      return {
        ...state,
        faq: {
          ...state.faq,
          questions: action.data,
        },
      };

    case AppTypes.SET_MOST_SEARCHED_FAQ:
      return {
        ...state,
        faq: {
          ...state.faq,
          mostSearched: action.data,
        },
      };

    case AppTypes.SET_SEARCHED_FAQ:
      return {
        ...state,
        faq: {
          ...state.faq,
          searchResults: action.data,
        },
      };

    case AppTypes.SET_FAQ_ANSWER:
      return {
        ...state,
        faq: {
          ...state.faq,
          answer: action.data,
        },
      };

    /* Mailbox */
    case AppTypes.GET_MAILBOX_EMAILS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          emailsLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_EMAILS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          emails: action.data,
          emailsLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_EMAILS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          emailsLoading: false,
        },
      };

    case AppTypes.GET_MAILBOX_SMS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          smsLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_SMS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          sms: action.data,
          smsLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_SMS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          smsLoading: false,
        },
      };

    case AppTypes.GET_MAILBOX_ALL:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          allLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_ALL:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          all: action.data,
          allLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_ALL_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          allLoading: false,
        },
      };

    case AppTypes.GET_MAILBOX_DOCUMENTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          documentsLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_DOCUMENTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          documents: action.data,
          documentsLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_DOCUMENTS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          documentsLoading: false,
        },
      };

    case AppTypes.GET_MAILBOX_REQUESTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          requestsLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_REQUESTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          personal_requests: action.data,
          requestsLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_REQUESTS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          requestsLoading: false,
        },
      };

    case AppTypes.GET_INVESTMENTS_FOR_SALE:
      return {
        ...state,
        investmentsForSaleLoading: true,
      };
    case AppTypes.SET_INVESTMENTS_FOR_SALE:
      return {
        ...state,
        investmentsForSale: action.payload,
        investmentsForSaleLoading: false,
      };
    case AppTypes.SET_GLOBAL_SERVER_ERROR_VISIBILITY:
      return {
        ...state,
        app: {
          ...state.app,
          globalErrorVisible: action.payload,
        },
      };

    case AppTypes.GET_MAILBOX_LETTERS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          lettersLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_LETTERS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          letters: action.data,
          lettersLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_LETTERS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          lettersLoading: true,
        },
      };

    case AppTypes.GET_RESOURCES_SUCCESS:
      return {
        ...state,
        resourcesOverview: action.payload,
      };

    case AppTypes.GET_MAILBOX_REPORTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          reportsLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_REPORTS:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          reports: action.payload,
          reportsLoading: false,
        },
      };
    case AppTypes.GET_MAILBOX_REPORTS_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          reportsLoading: false,
        },
      };
    case AppTypes.SET_MAILBOX_REPORTS_SUBSCRIPTION_USER:
      return {
        ...state,
        user: {
          ...state.user,
          send_reports: action.payload,
        },
        mailbox: {
          ...state.mailbox,
          reportSubscriptionLoading: false,
        },
      };
    case AppTypes.SET_MAILBOX_REPORTS_SUBSCRIPTION:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          reportSubscriptionLoading: true,
        },
      };
    case AppTypes.SET_MAILBOX_REPORTS_SUBSCRIPTION_ERROR:
      return {
        ...state,
        mailbox: {
          ...state.mailbox,
          reportSubscriptionLoading: false,
        },
      };
    case AppTypes.SET_INVESTOR_OFFERS_COUNT:
      return {
        ...state,
        offers: {
          ...state.offers,
          typesCounts: {
            ...action.payload,
          },
        },
      };
    case AppTypes.GET_DEPOSIT_QR_CODE_STRING:
      return {
        ...state,
        deposits: {
          ...state.deposits,
          qrCodeString: null,
          qrCodeStringError: false,
        },
      };
    case AppTypes.GET_DEPOSIT_QR_CODE_STRING_ERROR:
      return {
        ...state,
        deposits: {
          ...state.deposits,
          qrCodeString: null,
          qrCodeStringError: true,
        },
      };
    case AppTypes.SET_DEPOSIT_QR_CODE_STRING:
      return {
        ...state,
        deposits: {
          ...state.deposits,
          qrCodeString: action.payload,
          qrCodeStringError: false,
        },
      };
    case AppTypes.RESET_DEPOSIT_QR_CODE_STRING:
      return {
        ...state,
        deposits: {
          ...state.deposits,
          qrCodeString: null,
          qrCodeStringError: false,
        },
      };
    case AppTypes.GET_ESTIMATED_EARNINGS_GRAPH_DATA:
      return {
        ...state,
        estimates: {
          ...state.estimates,
          chartDataLoading: true,
        },
      };
    case AppTypes.SET_ESTIMATED_EARNINGS_GRAPH_DATA:
      return {
        ...state,
        estimates: {
          ...state.estimates,
          chartData: action.payload,
          chartDataLoading: false,
        },
      };

    default:
      return state;
  }
};
